import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import css from './GroupSession.css'
import {Card} from "semantic-ui-react";
import GroupSessionInformation from "./GroupSessionInformation";

function GroupSession(props) {
  const inputRef = useRef();
  const { groupSession } = props;
  return (
    <Card 
      style={{border: props.isChecked ? "1px solid #1E70A6" : null}}
      fluid 
      onClick={() => {
        props.selectGroupSession(groupSession);
        inputRef.current.focus();
      }}>
      <div className={css['card']}>
        <input 
          type='radio'
          ref={inputRef}
          name={'group-session'}
          id={groupSession.id}
          aria-labelledby={"gs" + groupSession.id}
          onChange={() => props.selectGroupSession(groupSession)}
          checked={props.isChecked}
          className={css['input-radio']}
        />
        <GroupSessionInformation
          groupSession={groupSession}
          labelId={"gs" + groupSession.id}
        />
      </div>
    </Card>
  )
}

GroupSession.propTypes = {
  groupSession: PropTypes.object,
  selectGroupSession: PropTypes.func,
  isChecked: PropTypes.bool.isRequired
};

export default GroupSession;
